import { render, staticRenderFns } from "./witz01.vue?vue&type=template&id=0f7591f6&"
import script from "./witz01.vue?vue&type=script&setup=true&lang=js&"
export * from "./witz01.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports